import styledComponent from 'styled-components';

const StyledHourPickerGrid = styledComponent.div`
  display: grid;
  gap: 0.5rem;
  grid-template-columns: repeat(3, 1fr);
  padding: 1rem;
  width: 100%;
  box-sizing: border-box;
`;

export default StyledHourPickerGrid;
